import ApiBudgety from '@/api/apiBudgety'
import { MenusSistema } from '@/Helper/Segurity'

export const estadoTratoService = {
  getAll,
}

async function getAll() {
  return await ApiBudgety.get('EstadoTrato/GetAll/')
}
